export default{
    wcOrderDetail:{
        table:{
            tab1:'订单编号',
            tab2:'商家名称',
            tab3:'订单金额',
            tab4:'退款金额',
            tab5:'应付金额',
            tab6:'操作',
            tab7:'全选',
        },
        msgState:{
            msg1:'已选择3个订单',
            msg2:'应付总计：',
        },
        btnState:{
            btn1:'查看详情',
            btn2:'提前结算',
            btn3:'提前结算',
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否需要商家开发票？',
            confirm6:'不要发票',
            confirm7:'需要发票',
        }
        
        
    }
    
}